import { auth } from './auth';
import { common } from './common';
import { course } from './course';
import { errors } from './errors';
import { format } from './format';
import { nav } from './nav';
import { player } from './player';
import { profile } from './profile';
import { record } from './record';
import { round } from './round';
import { rounds } from './rounds';
import { social } from './social';
import { stats } from './stats';

/**
 * O catálogo, plano.
 *
 * Chaves pontilhadas em vez de objeto aninhado: `MessageKey` vira um simples `keyof typeof catalog`,
 * sem tipo recursivo de caminho — o que mantém o editor rápido com centenas de chaves e a busca por
 * uma chave literal trivial.
 *
 * Os módulos são divididos por área só para o arquivo não crescer sem fim. Chave duplicada entre
 * módulos seria engolida em silêncio por este espalhamento, e é o que o `catalog.test.ts` verifica.
 */
export const catalog = {
  ...auth,
  ...common,
  ...course,
  ...errors,
  ...format,
  ...nav,
  ...player,
  ...profile,
  ...record,
  ...round,
  ...rounds,
  ...social,
  ...stats,
} as const;
